module.exports = __webpack_public_path__ + "media/images/1-highlighted-16fbc857.png";